import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import type { FormSchema, Schema } from '@cli-types/core-engine/schema.js'
import { validateEntitySchema } from '@core-engine/schema/schema-reader/validate-entity-schema.js'
import { validateFormSchema } from '@core-engine/schema/schema-reader/validate-form-schema.js'
import { validateSingleSchema } from '@core-engine/schema/schema-reader/validate-single-schema.js'
import { collectFieldNameValidationErrors } from './collect-field-name-validation-errors.js'

export function validateAuthoredGeneratedSchema(loaded: LoadedAuthoredGeneratedSchema): string[] {
  const schemaValidationErrors =
    loaded.kind === 'form'
      ? validateFormSchema(loaded.schema as FormSchema)
      : loaded.kind === 'single'
        ? validateSingleSchema(loaded.schema as Schema)
        : validateEntitySchema(loaded.schema as Schema)

  return [...schemaValidationErrors, ...collectFieldNameValidationErrors(loaded)]
}
